import { useEffect, useLayoutEffect } from "react";
import { canUseDOM } from "web/script/utils/browser/can-use-dom";

export default canUseDOM() ? useLayoutEffect : useEffect;
